export default {
  // Options.jsx
  items_per_page: '/ pàgina',
  label_items_per_page: 'Items / page',
  jump_to: 'Anar a',
  jump_to_confirm: 'Confirma',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Pàgina prèvia',
  next_page: 'Pàgina següent',
  prev_5: '5 pàgines prèvies',
  next_5: '5 pàgines següents',
  prev_3: '3 pàgines prèvies',
  next_3: '3 pàgines següents',
};
